import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { useState, useMemo } from 'react';

function ListableInfo(_ref) {
  let {
    disableEmptyFallback,
    label,
    value,
    size = 'sm',
    orientation = 'horizontal',
    style,
    className,
    labelStyle,
    valueStyle,
    wrap,
    labelClassName: labelClassNameProps
  } = _ref;
  const [showMore, setShowMore] = useState(false);
  const isMore = useMemo(() => typeof value === 'string' && value.length > 400, [value]);
  const classes = clsx('listable-info', {
    ["listable-info--".concat(size)]: size,
    ["listable-info--".concat(orientation)]: orientation,
    ["listable-info--with-more"]: isMore,
    ["listable-info--wrap"]: wrap
  }, className);
  const labelIsString = typeof label === 'string';
  if (labelIsString) {
    const endsWithColon = /(:|\*:$)/g.test(label);
    if (!endsWithColon) {
      label = "".concat(label, ":");
    }
  }
  const valueContent = useMemo(() => {
    if (!isMore || showMore || !value) {
      if (!value) {
        return disableEmptyFallback ? value : '-';
      }
      return value;
    }
    return jsxs("span", {
      children: [value.toString().slice(0, 400), "...", ' ', jsx("a", {
        className: "listable-info__more-button",
        onClick: () => {
          setShowMore(true);
        },
        children: "read more"
      })]
    });
  }, [isMore, showMore, value, disableEmptyFallback]);
  const labelClassName = clsx('listable-info__label', labelClassNameProps);
  return jsxs("div", {
    className: classes,
    style: style,
    children: [jsx("span", {
      className: labelClassName,
      style: labelStyle,
      children: label
    }), jsx("span", {
      className: "listable-info-value flex align-items-center",
      style: valueStyle,
      children: valueContent
    })]
  });
}

export { ListableInfo };
